
import { DataKey } from 'pages/Dashboard/components/AppleHealthActivitySummaryChart';
import { TimeFrameOptions } from 'pages/Dashboard/utils/trackingUtils';
import React from 'react';
import SleepComponent from 'pages/Dashboard/components/SleepComponent';
import ActivityComponent from 'pages/Dashboard/components/ActivityComponent';
import SummaryChart from 'pages/Dashboard/components/SummaryComponent';

const waypointDataMap = {
  sleepAppleHealth: {
    title: 'Sleep',
    subtitle: 'Time in bed',
    unit: 'hours',

  },
  sleepDerived: {
    title: 'Sleep',
    subtitle: 'Time in bed',
    unit: 'hours',

  },
  activityDerived: {
    title: 'Total Calories Burned',
    subtitle: 'active + resting',
    icon: 'Whatshot',
    unit: 'calories',
    dataKey: DataKey.TotalCaloriesBurned,
    yAxisDefinition: 'Calories',
  },
  stepCountDerived: {
    title: 'Steps',
    subtitle: '',
    icon: 'directions_walk',
    unit: 'steps',
    dataKey: DataKey.Steps,
    yAxisDefinition: 'Steps',

  },
  daylightExposure: {
    title: 'Time in daylight',
    subtitle: '',
    icon: 'sun',
    unit: 'min',
    dataKey: DataKey.DaylightExposure,
    yAxisDefinition: 'Duration',

  },
};
interface AppleHealthCommonChartProps {
  timeFrame: TimeFrameOptions;
  waypointId:string;
  patientId:string;
  providerId:string;
  title:string;
  subtitle:string;
  type:string;
  setCardStatus?: (type:string, v: boolean) => void;
  numberOfCards:number;
  setLoading?: (value:boolean) => void
  onChangeTimeFrame: (v: string) => void;
  yAxisDefinition?: string;
  dataKey?: DataKey;
  unit?: string;
  openDrawer?: () => void;
  }

export default function AppleHealthCommonChart(props: AppleHealthCommonChartProps) {
  const {
    timeFrame,
    patientId,
    providerId,
    type,
    waypointId,
    openDrawer,
    title,
    subtitle,
    onChangeTimeFrame,
    setCardStatus,
    numberOfCards,
  } = props;

  // @ts-ignore
  const waypointData = waypointDataMap[type as keyof waypointDataMap];
  const getChartComponent = () => {
    if (type === 'sleepDerived' || type === 'sleepAppleHealth') {
      return (
        <SleepComponent
          timeFrame={timeFrame}
          waypointId={waypointId}
          patientId={patientId}
          providerId={providerId}
          openDrawer={openDrawer}
          title={title}
          subtitle={subtitle}
          key={waypointId}
          {...waypointData}
          onChangeTimeFrame={onChangeTimeFrame}
          type={type}
          setCardStatus={setCardStatus}
          numberOfCards={numberOfCards}
        />
      );
    }
    else if (type === 'activityDerived' || type === 'activityAppleHealth') {
      return (
        <ActivityComponent
          timeFrame={timeFrame}
          waypointId={waypointId}
          patientId={patientId}
          providerId={providerId}
          title={title}
          subtitle={subtitle}
          key={waypointId}
          {...waypointData}
          type={type}
          setCardStatus={setCardStatus}
          numberOfCards={numberOfCards}
        />
      );
    }
    else if (type === 'stepCountDerived') {
      return (
        <SummaryChart
          timeFrame={timeFrame}
          waypointId={waypointId}
          patientId={patientId}
          providerId={providerId}
          title={title}
          subtitle={subtitle}
          key={waypointId}
          {...waypointData}
          type={type}
          setCardStatus={setCardStatus}
          numberOfCards={numberOfCards}
        />
      );
    }
    return (
      <SummaryChart
        timeFrame={timeFrame}
        waypointId={waypointId}
        patientId={patientId}
        providerId={providerId}
        title={title}
        subtitle={subtitle}
        key={waypointId}
        type={type}
        {...waypointData}
        setCardStatus={setCardStatus}
        numberOfCards={numberOfCards}
      />
    );
  };
  return (
    <React.Fragment key={waypointId}>
      {getChartComponent()}
    </React.Fragment>
  );
}
